import toaster from 'react-hot-toast';

import { CloseIcon, SlashCircle01Icon } from '@/assets/icons';
import { mergeClasses } from '@/utils';

import { ICustomErrorToast } from './Alert.interfaces';
import styles from './Alert.module.css';

const ToastError: React.FC<ICustomErrorToast> = ({ message, t }: ICustomErrorToast) => {
  return (
    <div
      className={mergeClasses(
        // Base classes
        'font-semibold text-sm max-w-[550px] flex items-center bg-semantic-error-base rounded-soft p-base text-white',
        // State-based classes
        t.visible ? styles['animate-enter'] : styles['animate-leave'],
      )}
    >
      <div className="mr-s-plus">
        <SlashCircle01Icon />
      </div>
      <div className="mr-m break-normal">{message}</div>
      <button onClick={() => toaster.dismiss(t.id)}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default ToastError;
